// extracted by mini-css-extract-plugin
export default {"outlineRoot":"AfaButton_outlineRoot__Z5ePD"};